import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ParentSegmentsStateProxyService} from '../../parent-segments-state-proxy.service';
import {Observable} from 'rxjs';
import {Segment} from '../../segment.model';
import {FormControl} from '@angular/forms';
import {map, shareReplay} from 'rxjs/operators';
import {flattenToSegments} from '../../segments.state';

@Component({
  selector: 'app-parent-segment',
  template: `
    <app-input-dropdown *ngIf="parentSegments$ | async; else spinner"
                        [data]="parentSegments$ | async"
                        [inputControl]="parentSegmentControl"
                        [label]="'Parent segments'"
                        (valueChange)="parentSelectionChanged.emit($event)"
                        [placeholder]="'Parent segment'">
    </app-input-dropdown>
    <ng-template #spinner>
§§
    </ng-template>
  `,
  styleUrls: ['./parent-segment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ParentSegmentComponent implements OnInit {
  @Input() parentSegmentControl!: FormControl;
  @Output() parentSelectionChanged = new EventEmitter<Segment>();
  parentSegments$: Observable<Segment[]> = this.parentSegmentProxy.getCandidates()
    .pipe(
      map(it => flattenToSegments(it)),
      shareReplay(1),
    );

  constructor(private parentSegmentProxy: ParentSegmentsStateProxyService) {
  }

  ngOnInit(): void {
    this.parentSegmentProxy.findCandidates();
  }

}
